import React, { useImperativeHandle, useState, useRef, useEffect } from "react";
import { Popup, PopupRef, Position, ToolbarItem } from 'devextreme-react/popup';
import DataGrid, { Button, Column, DataGridRef, Editing, FilterRow, Form, Pager, Paging } from "devextreme-react/data-grid";
import 'devextreme-react/text-area';
import { useNavigate } from "react-router-dom";
import { useScreenSize } from "../../utils/media-query";
import EnteEditPanel, { EnteEditPanelHandle } from "./enteEditPanel";

type Props = {
  onHidden?: () => void;
  onDataChanged?: () => void;
}

export type EnteEditPopupHandle = {
  edit: (enteId: string, title?: string) => void,
  new: () => void
}

type state = {
  enteId?: string,
  visible: boolean
}

const EnteEditPopup: React.ForwardRefRenderFunction<EnteEditPopupHandle, Props> = (props, ref) => {
  const [state, setState] = useState<state>({ enteId: undefined, visible: false  });
  const [popupTitle, setPopupTitle] = useState<string>("Ente");
  const { isXSmall, isSmall } = useScreenSize();
  const [fullscreen, setFullscreen] = useState(isXSmall || isSmall);
  const enteEditPanelRef = useRef<EnteEditPanelHandle>(null);

  function hide() {
    setState({ enteId: undefined, visible: false });
    props.onHidden?.();
  }

  async function SaveAndClose() {
    if (await enteEditPanelRef.current?.save()) {
       props.onDataChanged?.();
      hide();
    }
  }

  useImperativeHandle(ref, () => ({
    edit(enteId, title) {
      setState({
        enteId: enteId,
        visible: true
      });
      if (title)
        setPopupTitle(title);
    },
    new() {
      setState({
        enteId: undefined,
        visible: true
      });
    }
  }));

  return (
    <React.Fragment>
      {state.visible &&
      <Popup
        visible={true}
        dragEnabled={false}
        hideOnOutsideClick={false}
        showCloseButton={true}
        fullScreen={fullscreen}
        showTitle={true}
        onHidden={hide}
        title={popupTitle}
        container=".dx-viewport"
      >
        <Position
          at="center"
          my="center"
          of=""
          collision="fit"
        />
        <ToolbarItem
          widget="dxButton"
          toolbar="top"
          location="after"
          //visible={!(isXSmall || isSmall)}  
          options={{
            icon: 'fullscreen',
            onClick: () => setFullscreen(!fullscreen),
          }}
        />
         <ToolbarItem
          widget="dxButton"
          toolbar="bottom"
          location="after"
          options={{
            text: 'Salva',
            type: 'default',
            stylingMode: 'contained',
            onClick: SaveAndClose
          }}
        />
         <ToolbarItem
          widget="dxButton"
          toolbar="bottom"
          location="after"
          options={{
            text: 'Annulla',
            type: 'normal',
            stylingMode: 'contained',
            onClick: hide
          }}
        />
       
        <EnteEditPanel ref={enteEditPanelRef} enteId={state.enteId} />
      </Popup>
      }
    </React.Fragment>
  );
}

export default React.forwardRef(EnteEditPopup);
